import { render, staticRenderFns } from "./index.vue?vue&type=template&id=16c2487d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=16c2487d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2487d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c2487d')) {
      api.createRecord('16c2487d', component.options)
    } else {
      api.reload('16c2487d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=16c2487d&scoped=true&", function () {
      api.rerender('16c2487d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/start/create/index.vue"
export default component.exports